import type { Character, Profession } from './types'

export const CHARACTERS: Character[] = [
  { id: 'millo', name: 'มิลโล่', emoji: '🐱', color: '#ffb454', tagline: 'แมวส้มนักลงทุน หลับเก่ง แต่ตื่นมาปิดดีลเสมอ' },
  { id: 'budgie', name: 'บัดจี้', emoji: '🐶', color: '#7fc4ff', tagline: 'หมาน้อยขาซิ่ง ชอบซื้อทุกอย่างที่เหยียบ' },
  { id: 'porto', name: 'พอร์ตโต้', emoji: '🐼', color: '#c9d4e6', tagline: 'แพนด้าสายกระจายพอร์ต ไม่รีบแต่ไม่พลาด' },
  { id: 'richie', name: 'ริชชี่', emoji: '🐰', color: '#ff9ec4', tagline: 'กระต่ายกระโดดไว ชอบเลเวอเรจแบบสุดตัว' },
  { id: 'finn', name: 'ฟินน์', emoji: '🦊', color: '#ff8a5c', tagline: 'จิ้งจอกเจ้าเล่ห์ ต่อรองเก่งเป็นที่หนึ่ง' },
  { id: 'kevin', name: 'เควิน', emoji: '🐸', color: '#8ee06a', tagline: 'กบสายคริปโต ขาดทุนก็ยังยิ้มได้' },
  { id: 'pete', name: 'พีท', emoji: '🐧', color: '#87e8f0', tagline: 'เพนกวินสายเซฟ เงินสดต้องมีสำรองเสมอ' },
  { id: 'warren', name: 'วอร์เรน', emoji: '🦉', color: '#d9b97a', tagline: 'นกฮูกเฒ่าผู้อดทน ถือของดีไม่ปล่อย' },
]

const exp = (tax: number, home: number, car: number, card: number, other: number) => ({
  tax,
  home,
  car,
  card,
  other,
})

export const PROFESSIONS: Profession[] = [
  {
    id: 'teacher',
    name: 'ครูโรบอท',
    emoji: '🧑‍🏫',
    salary: 32_000,
    expenses: exp(4_200, 8_000, 3_000, 1_800, 4_500),
    startingCash: 60_000,
    childCost: 3_000,
    perk: 'รายจ่ายต่ำที่สุด หลุดวงจรหนูได้ไวถ้าขยันเก็บสินทรัพย์',
    perkId: 'frugal',
  },
  {
    id: 'engineer',
    name: 'วิศวกร AI',
    emoji: '🧑‍💻',
    salary: 68_000,
    expenses: exp(12_000, 14_000, 6_500, 4_000, 7_000),
    startingCash: 95_000,
    childCost: 5_000,
    perk: 'จั่วการ์ด DEAL ได้เลือกจาก 2 ใบ',
    perkId: 'dealSense',
  },
  {
    id: 'doctor',
    name: 'หมอนาโน',
    emoji: '🧑‍⚕️',
    salary: 135_000,
    expenses: exp(32_000, 34_000, 12_000, 9_000, 14_000),
    startingCash: 160_000,
    childCost: 9_000,
    perk: 'เงินเดือนสูงมาก แต่รายจ่ายก็โหด — เกมสอนบทเรียนคลาสสิก',
    perkId: 'none',
  },
  {
    id: 'mechanic',
    name: 'ช่างซ่อมหุ่นยนต์',
    emoji: '🧑‍🔧',
    salary: 42_000,
    expenses: exp(5_500, 9_500, 4_000, 2_500, 5_000),
    startingCash: 70_000,
    childCost: 3_500,
    perk: 'ค่าอัปเกรดโฉนดถูกลง 25%',
    perkId: 'cheapLoan',
  },
  {
    id: 'chef',
    name: 'เชฟอวกาศ',
    emoji: '🧑‍🍳',
    salary: 38_000,
    expenses: exp(5_000, 9_000, 3_500, 2_200, 5_500),
    startingCash: 110_000,
    childCost: 3_500,
    perk: 'เริ่มเกมด้วยเงินสดก้อนใหญ่',
    perkId: 'none',
  },
  {
    id: 'detective',
    name: 'นักสืบไซเบอร์',
    emoji: '🕵️',
    salary: 48_000,
    expenses: exp(7_000, 10_000, 4_500, 2_800, 5_200),
    startingCash: 75_000,
    childCost: 4_000,
    perk: 'เริ่มเกมมีโล่พลังงาน 1 ชั้น กันโทษไซไฟได้ 1 ครั้ง',
    perkId: 'sturdy',
  },
  {
    id: 'artist',
    name: 'ศิลปินโฮโล',
    emoji: '🧑‍🎨',
    salary: 29_000,
    expenses: exp(3_500, 7_500, 2_500, 1_500, 4_000),
    startingCash: 55_000,
    childCost: 2_800,
    perk: 'ทอยเต๋าใหม่ได้ 1 ครั้งต่อรอบ',
    perkId: 'lucky',
  },
  {
    id: 'pilot',
    name: 'นักบินอวกาศ',
    emoji: '🧑‍🚀',
    salary: 92_000,
    expenses: exp(20_000, 22_000, 9_000, 6_000, 10_000),
    startingCash: 120_000,
    childCost: 6_500,
    perk: 'ผ่อนโฉนดดาวน์แค่ 10% — เลเวอเรจสุดโต่ง',
    perkId: 'bigDown',
  },
]

export const BOT_NAMES = ['บอทซีโร่', 'บอทวัน', 'บอททู', 'บอทธรี', 'บอทโฟร์']
